import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { loginStudent } from "../../api/utils";

const LoginForm = ({ test_id }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", otp: "" });
  const [otpRequested, setOtpRequested] = useState(false);
  const [toast, setToast] = useState({ show: false, message: "", bg: "" });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const showToast = (message, bg = "bg-success") => {
    setToast({ show: true, message, bg });
    setTimeout(() => setToast((prev) => ({ ...prev, show: false })), 3000);
  };

  const handleRequestOtp = async (e) => {
    e.preventDefault();
    if (!formData.email)
      return showToast("Please enter your email.", "bg-danger");

    try {
      const response = await loginStudent({ email: formData.email });
      if (response.status) {
        setOtpRequested(true);
        showToast(response.message || "OTP sent successfully.", "bg-success");
      } else {
        showToast(response.message || "Failed to send OTP.", "bg-danger");
      }
    } catch (error) {
      let errorMessage = "Something went wrong. Try again.";

      if (error.response) {
        errorMessage = error.response.data?.message || errorMessage;
      } else if (error.request) {
        errorMessage = "No response from server. Check your network.";
      } else {
        errorMessage = error.message;
      }

      showToast(errorMessage, "bg-danger");
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!formData.email || !formData.otp)
      return showToast("Please fill in all fields.", "bg-danger");

    try {
      const payload = {
        email: formData.email,
        otp: formData.otp,
        test_id,
      };

      const response = await loginStudent(payload);
      if (response.status) {
        localStorage.setItem("isLoggedIn", true);
        localStorage.setItem("authToken", response.token);
        // localStorage.setItem("user_id", response.user_id);
        showToast(response.message || "Login successful.", "bg-success");

        const url = "/examination/landing";
        navigate(url);
      } else {
        showToast(response.message || "Invalid OTP.", "bg-danger");
      }
    } catch (error) {
      let errorMessage = "Something went wrong. Try again.";

      if (error.response) {
        errorMessage = error.response.data?.message || errorMessage;
      } else if (error.request) {
        errorMessage = "No response from server. Check your network.";
      } else {
        errorMessage = error.message;
      }

      showToast(errorMessage, "bg-danger");
    }
  };
  return (
    <div className="col d-flex justify-content-center">
      <div
        className="card p-4 rounded-4 shadow"
        style={{ maxWidth: "500px", width: "100%" }}
      >
        <form onSubmit={otpRequested ? handleLogin : handleRequestOtp}>
          <div className="mb-3">
            <label className="form-label fw-semibold">E-mail</label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter E-mail ID"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          {otpRequested && (
            <div className="mb-3">
              <label>Enter OTP</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter the OTP"
                name="otp"
                value={formData.otp}
                onChange={handleChange}
                required
              />
            </div>
          )}

          <button
            type="submit"
            className="primary-button btn-lg btn btn-primary w-100 rounded-pill mt-2"
          >
            {otpRequested ? "Login" : "Request OTP"}
          </button>
        </form>
      </div>
      {toast.show && (
        <div
          className={`toast align-items-center text-white ${toast.bg} position-fixed top-0 end-0 m-3 show`}
          role="alert"
          style={{ zIndex: 9999 }}
        >
          <div className="d-flex">
            <div className="toast-body">{toast.message}</div>
            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              aria-label="Close"
              onClick={() => setToast({ ...toast, show: false })}
            ></button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginForm;
